import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AnnouncementConfirmationInfo } from '../Announcement.types';

type AnnouncementConfirmationIndicator = {
  id: string;
  confirmationInfoText: string | null;
} & AnnouncementConfirmationInfo;

export function AnnouncementConfirmationIndicator({
  id,
  confirmationInfo,
  confirmationInfoText,
}: AnnouncementConfirmationIndicator) {
  const { t } = useSonTranslation('Announcement');
  return (
    <div className="announcement__mandatory-container">
      <span className="invisible">{t('mandatory.text')}</span>
      <div className="announcement__meter-container">
        <div className="announcement__meter-inner-container">
          <label htmlFor={`confirmation-info-${id}`} className="invisible">
            {t('mandatory.confirmations')}
          </label>
          <meter
            className="announcement__meter"
            id={`confirmation-info-${id}`}
            value={confirmationInfo?.confirmed}
            min={0}
            max={confirmationInfo.confirmed + confirmationInfo.unconfirmed}
          >
            {/* for screen reader users */}
            {confirmationInfoText}
          </meter>
        </div>
      </div>
      {/* for visual users */}
    </div>
  );
}
